import React from 'react';
import Button from '@/components/ui/Button';
import MatchBrowser from '@/components/team/MatchBrowser';

interface MatchBrowserSectionProps {
  showMatchBrowser: boolean;
  onToggle: () => void;
  onMatchLoaded: React.ComponentProps<typeof MatchBrowser>['onMatchLoaded'];
}

const MatchBrowserSection: React.FC<MatchBrowserSectionProps> = ({
  showMatchBrowser,
  onToggle,
  onMatchLoaded,
}) => {
  return (
    <div className="space-y-3">
      <Button
        variant="outline"
        onClick={onToggle}
      >
        {showMatchBrowser ? 'Hide Match Browser' : 'Load from Match'}
      </Button>
      {showMatchBrowser && (
        <MatchBrowser onMatchLoaded={onMatchLoaded} />
      )}
    </div>
  );
};

export default MatchBrowserSection;
